import type { SVGProps } from 'react'
const SvgScanError = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.59961 6.33789V10.9531C6.59961 12.9323 7.16055 14.7305 8.28223 16.3496C9.39756 17.9595 10.8035 19.0321 12.5 19.5732C14.1965 19.0321 15.6025 17.9605 16.7178 16.3506C17.8394 14.7315 18.4004 12.9333 18.4004 10.9541V6.33789L12.5 4.16309L6.59961 6.33789ZM19.5996 10.9531C19.5996 13.257 18.9292 15.3309 17.5879 17.1699C16.2474 19.0077 14.5603 20.2285 12.5283 20.8281L12.5 20.8369L12.4717 20.8281C10.4397 20.2299 8.75264 19.0097 7.41211 17.1719C6.07079 15.3329 5.40039 13.2583 5.40039 10.9531V5.52246L5.46484 5.49805L12.4648 2.90527L12.5 2.89258L12.5352 2.90527L19.5352 5.49805L19.5996 5.52246V10.9531Z"
      fill="#E8871F"
      stroke="#E8871F"
      strokeWidth="0.2"
    />
    <path
      d="M11.9038 13.1081L11.7052 6.99902H13.1615L12.9629 13.1081H11.9038ZM12.4333 16.3324C12.1774 16.3324 11.9567 16.2519 11.7714 16.0909C11.5905 15.9299 11.5 15.7188 11.5 15.4578C11.5 15.2837 11.5419 15.1314 11.6258 15.0009C11.7096 14.8704 11.8221 14.7681 11.9634 14.6941C12.1046 14.6202 12.2612 14.5832 12.4333 14.5832C12.6937 14.5832 12.9143 14.6637 13.0953 14.8247C13.2762 14.9857 13.3667 15.1967 13.3667 15.4578C13.3667 15.6318 13.3247 15.7841 13.2409 15.9146C13.1571 16.0452 13.0445 16.1474 12.9033 16.2214C12.7621 16.2954 12.6054 16.3324 12.4333 16.3324Z"
      fill="#E8871F"
    />
  </svg>
)

export default SvgScanError
